// Error Code
export const NOT_CONNECT_NETWORK = "NOT_CONNECT_NETWORK";

//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE =
  "Cannot connect to server, Please try again.";
export const NETWORK_TIMEOUT_MESSAGE =
  "A network timeout has occurred, Please try again.";

export const YES = "YES";
export const NO = "NO";

export const server = {
  LOGIN_URL: `/login`,
  LOGIN_PASSED: `yes`,
  BUILDING_URL: `/api/building`,
  LOCATION_URL: `/api/meeting-location`,
  ROOM_URL: `/api/room`,
  MEETING_URL: `/api/meetings`,
  POSITION_MEETING_URL:`/api/position-meeting`,
  POSITION_URL: `/api/position`,
  DEPARTMENT_URL: `/api/department`,
  TITLE_URL: `/api/title`,
  USER_URL: `/api/users`,
  ROLE_URL: `/api/roles`,
  GROUP_NAME_URL: `/api/group-name`,
  GROUP_ITEM_URL: `/api/group-detail`,
};
